import React from 'react';
import { useTranslation } from 'react-i18next';
const InputComponent = ({
  input,
  inputFileRequired,
  inputIdValue,
  handleInput,
  isRequired,
  isReadOnly,
}) => {
  const { t } = useTranslation();

  const checkConsernPosition =
    input.id === 'AuthorizeRepresentative' ||
    input.id === 'PartnerAuthorizeRepresentative'
      ? ''
      : 'xl:flex';
  const checkConsern =
    input.id === 'AuthorizeRepresentative' ||
    input.id === 'PartnerAuthorizeRepresentative'
      ? 'text-left pl-2 font-semibold mr-10'
      : 'w-screen max-w-xl self-center';

  const phoneFormat = (input, curValue) => {
    let x = curValue.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

    setTimeout(function () {
      document.getElementById(input).value = !x[2]
        ? x[1]
        : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }, 5);

    return (curValue = !x[2]
      ? x[1]
      : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
  };

  return (
    <div>
      {input.type === 'radio' ? (
        <div className={checkConsernPosition}>
          <p
            className={`${checkConsern} text-base text-gray-800 mb-1 pr-5 sm:pr-2 break-normal text-justify`}
          >
            {t(input.label)}
            {isRequired === true ? <sup className="text-red-500">*</sup> : null}
          </p>
          <div className="sm:flex self-center inline-flex">
            {input?.listOptions.map((opts, i) => (
              <div key={`${opts.id}-${i}`}>
                <label className="sm:flex font-semibold text-gray-800 self-center inline-block items-center h-4 mx-2">
                  <span className="px-0 inline-flex"></span>
                  <input
                    disabled={isReadOnly}
                    required={isRequired}
                    className="ml-3 mr-2"
                    id={input.id}
                    value={opts.value}
                    type={input.type}
                    onChange={handleInput}
                    name={input.label}
                    checked={String(opts.value) === inputIdValue}
                  />
                  <span className="text-blue-gray-800">{t(opts.label)}</span>
                </label>
              </div>
            ))}
          </div>
          {input?.uploadFileDependence && (
            <div className="flex justify-center">
              <input
                required={inputFileRequired}
                disabled={isReadOnly}
                accept="image/*,.pdf, .xls, .xlsx, .doc, .docx"
                className={`${
                  inputIdValue === input.uploadFileDependence
                    ? 'visible'
                    : 'hidden'
                } m-1 file:mr-4 file:py-2 file:px-4 self-center

              file:rounded-full file:border
              file:border-indigo-600
              file:text-sm file:font-semibold
              file:cursor-pointer
              file:bg-blue-500 file:text-white
              hover:file:bg-indigo-600`}
                type="file"
                id={input.id + 'Url'}
                multiple
                onChange={handleInput}
              />
            </div>
          )}
        </div>
      ) : (
        <>
          <label className="block font-semibold text-gray-800 mb-0.5 ml-1">
            {t(input.label)}
            {isRequired === true ? <sup className="text-red-500">*</sup> : null}
          </label>
          {input.type === 'textarea' && (
            <textarea
              readOnly={isReadOnly}
              required={isRequired}
              id={input.id}
              className="block w-full px-4 py-2 mb-1 text-blue-gray-800 bg-white border rounded focus:ring-blue-500 focus:outline-none focus:ring-2"
              type={input.type}
              placeholder={t(input.placeholder)}
              onChange={handleInput}
              defaultValue={inputIdValue}
              rows="4"
              cols="50"
              autocomplete="false"
            />
          )}
          {(input.type === 'text' ||
            input.type === 'number' ||
            input.type === 'date') && (
            <input
              readOnly={isReadOnly}
              required={isRequired}
              id={input.id}
              className="block w-full px-4 py-2 mb-1 text-blue-gray-800 bg-white border rounded focus:ring-blue-500 focus:outline-none focus:ring-2"
              type={input.type}
              inputMode={input.inputMode}
              placeholder={t(input.placeholder)}
              onChange={handleInput}
              defaultValue={inputIdValue}
              minLength={input.minLenght}
              maxLength={input.maxLenght}
              pattern={input.pattern}
              autocomplete="false"
            />
          )}
          {input.type === 'select' && (
            <select
              disabled={isReadOnly}
              title={input.id}
              id={input.id}
              onChange={handleInput}
              value={inputIdValue}
              className="block w-full px-3 py-2 mb-1 text-blue-gray-800 bg-white border rounded focus:ring-blue-500 focus:outline-none focus:ring-2"
            >
              {input?.listOptions?.map((elem, i) => {
                return (
                  <option key={`${i}-${elem.id}`} value={elem.value}>
                    {t(elem.label)}
                  </option>
                );
              })}
            </select>
          )}
          {input.type === 'phone' && (
            <input
              readOnly={isReadOnly}
              required={isRequired}
              id={input.id}
              className="block w-full px-4 py-2 mb-1 text-blue-gray-800 bg-white border rounded focus:ring-blue-500 focus:outline-none focus:ring-2"
              type="tel"
              maxLength={14}
              placeholder={t(input.placeholder)}
              onChange={handleInput}
              defaultValue={inputIdValue && phoneFormat(input.id, inputIdValue)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default InputComponent;
